import { styled } from 'styled-components';
import classnames from 'classnames';
import React from 'react';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
  svg {
    width: 100%;
    height: 100%;
  }
  &.fill {
    svg {
      path {
        fill: currentColor;
      }
    }
  }
`;
type SVGIconProps = {
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  className?: string;
  icon?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  fill?: boolean;
};
const SVGIcon = (props: SVGIconProps) => {
  const { style, width = 16, height, onClick, className, icon, fill, ...restProps } = props;
  return (
    <Container
      onClick={onClick}
      className={classnames('svg-icon', fill ? 'fill' : '', className)}
      style={{
        width: `${width}px`,
        height: `${height || width}px`,
        ...style,
      }}
      {...restProps}
    >
      {icon}
    </Container>
  );
};
export default SVGIcon;
